export default "__VITE_ASSET__CPlzwQWd__"